import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  IconButton,
  Typography,
} from '@material-ui/core';
import { RefreshRounded } from '@material-ui/icons';
import CircleIcon from '@material-ui/icons/FiberManualRecord';
import moment from 'moment';
import { mappedCurrentActiveRole } from '../../../../utils/roleMapping';
import apiCaller from '../../../../utils/apiCallerOutstanding';
import myFirebase from '../../../../config/config';
import logger from '../../../../utils/logger';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    marginTop: '20px',
    textAlign: 'left',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 1,
    fontSize: '14px',
  },
  commentBox: {
    maxHeight: '300px',
    overflowY: 'scroll',
    scrollbarWidth: 'thin',
    padding: '8px',
  },
  rajdhaniFont: {
    fontFamily: 'Rajdhani',
    margin: 0,
  },
  titleSection: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '5px',
    alignItems: 'center',
  },
  activityNotes: {
    marginLeft: '20px',
    fontSize: '12px',
    fontWeight: 300,
    marginBottom: '1px',
  },
});

export default function ActivitiesCard({ transactionId, activeRole }) {
  const [activitiesData, setActivitiesData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const classes = useStyles();
  const currentActiveRole = mappedCurrentActiveRole(activeRole);

  const getActivitiesData = async () => {
    setFetching(true);
    const userDetails = myFirebase.auth().currentUser;
    const token = await userDetails.getIdToken();
    const endPoint = `pipe/transactions/activities?role=${currentActiveRole}&transaction_id=${transactionId}`;
    if (token) {
      await apiCaller(endPoint, {}, `Bearer ${token}`, 'nh-base', 'get')
        .then(response => {
          setActivitiesData(response?.data?.activity_info || []);
          setFetching(false);
        })
        .catch(error => {
          setFetching(false);
          setActivitiesData([]);
          logger.error(error);
        });
    } else {
      setFetching(false);
    }
  };

  useEffect(() => {
    getActivitiesData();
  }, [transactionId, activeRole]);

  return (
    <Card className={classes.root}>
      <CardHeader
        title={
          <div className={classes.titleSection}>
            <p className={classes.rajdhaniFont}>Activity</p>
            <IconButton
              disabled={fetching}
              size="small"
              onClick={() => getActivitiesData()}
            >
              <RefreshRounded />
            </IconButton>
          </div>
        }
      />
      <Divider />
      {fetching ? (
        <CircularProgress size={20} />
      ) : (
        <CardContent className={classes.commentBox}>
          {activitiesData?.length === 0 ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
              >
                No Activity Available
              </Typography>
            </div>
          ) : null}
          {activitiesData?.length > 0 ? (
            <div style={{ margin: '10px' }}>
              {activitiesData?.map(activityDetail => (
                <div
                  style={{ marginBottom: '10px' }}
                  key={activityDetail?.activity_at}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'baseline',
                      gap: '10px',
                    }}
                  >
                    <CircleIcon
                      style={{
                        fontSize: '10px',
                      }}
                    />
                    <Typography className={classes.pos}>
                      {activityDetail?.activity_description}
                    </Typography>
                  </div>
                  {activityDetail?.activity_notes && (
                    <Typography className={classes.activityNotes}>
                      {activityDetail?.activity_notes}
                    </Typography>
                  )}
                  <Typography
                    variant="caption"
                    display="block"
                    gutterBottom
                    color="textSecondary"
                    style={{ marginLeft: '20px', fontSize: '10px' }}
                  >
                    {activityDetail?.activity_at && (
                      <>
                        {moment(activityDetail?.activity_at).format(
                          'MMM DD, YYYY'
                        )}
                        <CircleIcon
                          style={{
                            fontSize: '7px',
                            marginLeft: '5px',
                            marginRight: '5px',
                          }}
                        />

                        {moment(activityDetail?.activity_at).format('hh:mm A')}
                      </>
                    )}
                    {activityDetail?.activity_by && (
                      <>
                        <CircleIcon
                          style={{
                            fontSize: '7px',
                            marginLeft: '5px',
                            marginRight: '5px',
                          }}
                        />
                        {activityDetail?.activity_by}
                      </>
                    )}
                  </Typography>
                </div>
              ))}
            </div>
          ) : null}
        </CardContent>
      )}
    </Card>
  );
}
